import { useState, useEffect } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import './salesChart.css'

const EventSalesChart = ({ event_id }) => {
  const [loading, setLoading] = useState(true);
  const [sales, setSales] = useState([]);

  useEffect(() => {
    // console.log('useEffect EventSalesChart');
    const fetchSales = async() => {
      try {
        let _user = localStorage.getItem('_user');
        const _userToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_LOCALSTOAGE_KEY);
        _user = JSON.parse(_user);
        const response = await axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}/sales`, {
          headers: {
            'Authorization': 'Basic ' + btoa(_user.user_login + ":" + _userToken),
            'Content-Type': 'application/json',
          },
        });
        console.log('EventSalesChart - fetchSales', response);
        if (response.data.orders) {
          response.data.orders.map(order => {
            order.sales = parseFloat(order.order_total).toFixed(2)
            return order
          })
          let temp_orders = response.data.orders;
          temp_orders.map((order_data) => {
            order_data.order_date = formatXAxis(order_data.order_date)
          });
          setSales(temp_orders);          
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    fetchSales();
  }, []);

  // Function to format the date
  const formatXAxis = (tickItem) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [year, month] = tickItem.split('-');
    return `${months[parseInt(month, 10) - 1]} ${year}`;
  };

  // Function to format Y-axis labels
  const formatYAxis = (value) => `$${value}`;

  return (
    <div className="sales-chart-container">
      {loading && (
        <p>Loading...</p>
      )}
      {(!loading && sales) && (
        <ResponsiveContainer>
          <LineChart 
            data={sales}
            margin={{ top: 8, right: 32, left: 32, bottom: 8 }}
            style={{ backgroundColor: 'black' }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
            <XAxis dataKey="date" stroke="white"
              // tickerFormatter={formatXAxis}
            />
            <YAxis stroke="white"
              tickFormatter={formatYAxis}
            />
            <Tooltip 
              contentStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.75)', color: 'white' }} 
              // labelFormatter={(label) => formatXAxis(label)} 
              formatter={(value) => [`$${value}`, 'Sales']}
            />
            <Line type="monotone" dataKey="sales" stroke="#ffab2d" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default EventSalesChart;